import { isFuture, secondsToMilliseconds } from 'date-fns';

function shouldConsiderCatchupAsLive(endTime: number | undefined) {
    if (endTime) {
        return isFuture(secondsToMilliseconds(endTime));
    }

    return false;
}

export default shouldConsiderCatchupAsLive;
